// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1JNDw","tab":"Tabs_tab__33rCf","tabActive":"Tabs_tabActive__3Vie6"};